<ion-row>
  <ion-col>
    <ion-row class="nokkeltall-grid">
      <ion-col size="12">
        <ion-row class="row-m">
          <ion-col>
            <h2 class="yearTitleText">Forbruk per år</h2>
            <p *ngIf="isPlusskunde">netto etter produksjon</p>
          </ion-col>
        </ion-row>
        <ion-row [ngClass]="{ 'row-m': isBrowser }">
          <ion-col *ngFor="let data of yearsForbruk" class="box-col-nokkeltall">
            <p>
              {{ data.year }}
              <span *ngIf="data.year === thisYear.toString()">(hittil)</span>
            </p>
            <p class="nokkeltall">
              {{ toRoundNumber(data.sumForbruk) }}
              <span class="ion-hide-sm-down">kWh</span>
            </p>
            <p class="ion-hide-sm-up">kWh</p>
          </ion-col>
        </ion-row>
        <ion-row *ngIf="isBrowser" class="row-m">
          <ion-col>
            <h2 class="yearTitleText">Estimert kostnad per år</h2>
            <p *ngIf="isPlusskunde">netto etter inntekt</p>
          </ion-col>
        </ion-row>
        <ion-row *ngIf="isBrowser" class="row-m">
          <ion-col *ngFor="let data of yearsForbruk" class="box-col-nokkeltall">
            <p>
              {{ data.year }}
              <span *ngIf="data.year === thisYear.toString()">(hittil)</span>
            </p>
            <p class="nokkeltall">
              {{ toRoundNumber(data.sumKostnad) }}
              <span class="ion-hide-sm-down">kr</span>
            </p>
            <p class="ion-hide-sm-up">kr</p>
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>
  </ion-col>
</ion-row>
